import { useMemo, useState } from "react"
import { Defaults } from "../../../../../../modules/API/Defaults/defaults"
import useDataFetcher from "../../../knisot/hooks/useFetchData"
import { IProductListItemNode, IProductListNodeResponse } from "../../../../../../modules/API/Defaults/models/productListNode"
import { IGrowerNodeGetResponse } from "../../../../../../modules/API/Defaults/models/growers"
import { EXPIRATION_FILTER, IExpirationReportForm } from "../types/form"
import { Warehouse } from "../../../../../../modules/API/Warehouse/warehouse"
import { RootState } from "../../../../../../../store/reducers/rootReducer"
import { useDispatch, useSelector } from "react-redux"
import { IWarhouseListItem } from "../../../../../../modules/API/Defaults/models/warhouseList"
import selectBrodMigdal from "../../../../../../generic/utils/selectBrodMigdal"
import { IExpirationReportResponseItem } from "../../../../../../modules/API/Warehouse/models/responses"
import { mockExpirationReportData } from "../constance/mockData"
import { LOAD, LOAD_END } from "../../../../../../../store/actions/actionsTypes"
import { handleNotifications } from "../../../../../../generic/utils/handleNotifications"
import { ExpirationReportRow } from "../types/row"

export const useExpirationReportForm = () => {
  const dispatch = useDispatch()
  const defaults = useSelector((state: RootState) => state.defaults.defaults)
  const defaultWarehouseId = selectBrodMigdal(defaults, 5, "Num_Value")
  const [expirationReportList, setExpirationReportList] = useState<IExpirationReportResponseItem[] | null>(null)
  const [searchInput, setSearchInput] = useState<string>('')
  
    const [isOpen, setIsOpen] = useState<boolean>(true)
    const [productId, setProductId] = useState<number>(0)
    const [growerId, setGrowerId] = useState<number>(0)
    // last submitted filter values — keeps the form state across modal close/reopen
    const [formValues, setFormValues] = useState<IExpirationReportForm | null>(null)
    const {
      data: warehouseList,
    } = useDataFetcher<IWarhouseListItem[]>(
      Defaults.getWarhouseList, "data"
    )
    const {
        data: products,
    } = useDataFetcher<IProductListNodeResponse>(
        Defaults.getProductsList,
        'data'
    )

    const {
        data: growerList,
    } = useDataFetcher<IGrowerNodeGetResponse>(
        Defaults.getGrowerList, 'data'
    )

    const handleControlModal = () => {
      setIsOpen(!isOpen)
    }
    const handleSubmit = async (data: IExpirationReportForm) => {
      setFormValues(data)
      dispatch({type: LOAD})
        try {
          const response = await Warehouse.getExpirationReport({
            ProductID: data.productId,
            GrowerID: data.growerId,
            Location: data.location,
            DaysToExpiration: data.expirationFilter === EXPIRATION_FILTER.DAYS_TO_EXPIRATION ? Number(data.daysToExpiration) : 0,
            ExpirationFilter: data.expirationFilter,
            Occupancy: data.occupancy,
            Tranzit: data.warehouseId || 0,
            })
            setExpirationReportList(response.list)
            setIsOpen(false)
        } catch (error) {
          handleNotifications('שגיאה בטעינת דוח פג תוקף', { type: 'error' })
        } finally {
          dispatch({type: LOAD_END})
        }
    }
    const renderList = useMemo<ExpirationReportRow[] | null>(() => {
      if(!expirationReportList) return null
      return expirationReportList
        .filter(item => 
          item.productDesc.toLocaleLowerCase().includes(searchInput.toLocaleLowerCase())
          || item.GrowerName.toLocaleLowerCase().includes(searchInput.toLocaleLowerCase())
          || item.location.toLocaleLowerCase().includes(searchInput.toLocaleLowerCase())
          || item.EntryDetailNum.toString().includes(searchInput.toString())
        )
        .map((item, index) => ({ ...item, rowId: index }))
    }, [expirationReportList, searchInput])
  return (
    {
        handleSubmit,
        products: products?.products|| [],
        productId,
        setProductId,
        growerList: growerList?.growers || [],
        growerId,
        setGrowerId,
        isOpen,
        warehouseList: warehouseList || [],
        warehouseId: defaultWarehouseId || 0,
        formValues,
        expirationReportList: renderList,
        searchInput,
        setSearchInput,
        handleControlModal,
    }
  )
}